// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1lyTr","empty":"ModalGraph_empty__2vTd5"};